import { Match, MatchStat } from "@app/core/match/domain/model/match";
import { PlayerIdentificationData } from "@app/core/match/domain/model/player-identification-data";
import { DateMapper } from "@app/core/shared/data/network/date.mapper";

export class PlayerIdentificationMapper {
  static deserialize(response: any): PlayerIdentificationData {
    return {
      image: response.image,
      available_steps: response.available_steps,
      identified_players: Object.entries(response as any)
        .filter(
          ([key, value]) =>
            key.startsWith("player_") && (value as any).identified
        )
        .map(([key]) => key),
      zoom_image1: response.player_1.zoom_image1,
      zoom_image2: response.player_2.zoom_image1,
      zoom_image3: response.player_3.zoom_image1,
      zoom_image4: response.player_4.zoom_image1,
    };
  }
}
